import { AttachmentValidationMode, FileOrLink, ValidateAttachmentArguments, ValidateAttachmentSignature, checkMode } from "models/attachments";
import { useState } from "react";
import { fieldHasErrors } from "utils/validation-utils";

type ClientValidateAttachmentSignature = (mode: AttachmentValidationMode, data: ValidateAttachmentArguments) => [
    boolean,
    any
];

interface IClientAttachmentValidator {
    validate: ClientValidateAttachmentSignature;
    clearByMode: (summary: any, workingSummary: any, mode: AttachmentValidationMode) => void;
    canContinue: (summary: any, mode: AttachmentValidationMode, valid: boolean) => boolean;
}

type UseClientAttachmentValidationProps = {
    fileOrLink?: FileOrLink;
};

const NameInvalidCharactersRegex = /[\/:*?"<>|]/;
const ValidUrlRegex = /^(http|https|ftp|sftp):\/\/[^\s/$.?#].[^\s]*$/i;
const ValidFilenameRegex = /^(?=[\S])[^\/:*?"<>|]+$/;

const useClientAttachmentValidator: (props: UseClientAttachmentValidationProps) => IClientAttachmentValidator = (props: UseClientAttachmentValidationProps) => {
    const { fileOrLink } = props;
    
    const validateName = (newSummary: any, name?: string | null) => {
        console.log('validateName', name);
        if (name) {
            if (NameInvalidCharactersRegex.test(name)) {                
                newSummary.name = [ 'Attachment name does not allow \/:*?"<>|' ];
                return false;
            }
        } else {
            newSummary.name = [ 'Attachment name is required.' ];
            return false;
        }

        newSummary.name = [];
        return true;
    }

    const validateUrl = (newSummary: any, url?: string | null) => {
        if (url) {
            if (!ValidUrlRegex.test(url)) {
                newSummary.url = [ 'File URL is invalid.' ];
                return false;
            }
        } else {            
            newSummary.url = [ 'File URL is required.' ];
            return false;
        }
        
        newSummary.url = [];        
        return true;
    };

    const validateFiles = (newSummary: any, filenames?: string[]) => {
        if (filenames) {
            for (var filename in filenames) {
                var errorList = [];
                if (!ValidFilenameRegex.test(filename)) {
                    errorList.push(`Attachment ${filename} has an invalid file name.`);
                }

                if (errorList.length > 0) {                         
                    newSummary.file = errorList;
                    return false;
                }
            }
        } else {            
            newSummary.file = [ 
                'Attachment file is required.'
            ];
            return false;
        }

        newSummary.file = [];
        return true;
    };
    
    const validate: ClientValidateAttachmentSignature = (mode: AttachmentValidationMode, data: ValidateAttachmentArguments) => {
        const { name, url, filenames } = data;

        // Client-side validations
        let newSummary = { };
        let isValid = true;

        if (fileOrLink === FileOrLink.Link) {
            isValid = validateName(newSummary, name) && isValid;
        }
        if (fileOrLink !== FileOrLink.File) {
            isValid = validateUrl(newSummary, url) && isValid;
        } else {
            isValid = validateFiles(newSummary, filenames) && isValid;            
        }

        return [
            isValid,
            newSummary
        ];
    };

    
    const clearSummaryByMode = (oldSummary: any, newSummary: any, mode: AttachmentValidationMode) => {
        if (!checkMode(mode, 'file')) {
            newSummary.file = oldSummary.file;
        }
        if (!checkMode(mode, 'name')) {
            newSummary.name = oldSummary.name;
        }
        if (!checkMode(mode, 'url')) {
            newSummary.url = oldSummary.url;
        }
    };

    const canContinueForMode = (summary: any, mode: AttachmentValidationMode, valid: boolean) => {
        if (mode === 'full' && !valid) {
            return false; 
        }
        if (checkMode(mode, 'name') && fieldHasErrors(summary, 'name')) {
            return false;
        }
        if (checkMode(mode, 'url') && fieldHasErrors(summary, 'url')) {
            return false;
        }
        if (checkMode(mode, 'file') && fieldHasErrors(summary, 'file')) {
            return false;
        }        
        return true;
    };

    return {
        validate,
        clearByMode: clearSummaryByMode,
        canContinue: canContinueForMode
    }
};

export default useClientAttachmentValidator;